import { createContext } from 'react';

export interface DataListContextValue {
  groups: string[];
}

export const DataListContext = createContext<DataListContextValue>({
  groups: [],
});
